"use client";
const URL_AUTH = '/auth'

export const startTrial = '/signup'
export const openSample = "window.open('/sample-report', '_blank')";
export const contactSales = 'mailto:sales@ablelytics.com?subject=Demo%20request%20for%20Ablelytics'


export const URL_FRONTEND_FEATURES = "/features"
export const URL_FRONTEND_PRICING = "/pricing"
export const URL_FRONTEND_FAQS = "/faqs"
export const URL_FRONTEND_CONTACT = "/contact"
export const URL_FRONTEND_INTEGRATIONS = "/integrations"
export const URL_FRONTEND_WHY_ACCESSIBILITY = "/why-accessibility"
export const URL_FRONTEND_ABOUT = "/about"
export const URL_FRONTEND_SOLUTIONS = "/solutions"

export const URL_FRONTEND_CASE_STUDIES = "/case_studies"
export const URL_FRONTEND_BLOG = "/blog"
export const URL_FRONTEND_GUIDES = "/guides"
export const URL_FRONTEND_ACCESSIBILITY_RULES = "/accessibility-rules"

export const URL_FRONTEND_PRIVACY = "/privacy"
export const URL_FRONTEND_TERMS = "/terms"
export const URL_FRONTEND_COOKIES = "/cookies"

// Solution pages
export const URL_FRONTEND_SOLUTIONS_COMPLIANCE = "/solutions/compliance"
export const URL_FRONTEND_SOLUTIONS_AGENCIES = "/solutions/agencies"
export const URL_FRONTEND_SOLUTIONS_DEVELOPERS = "/solutions/developers"


export const URL_DOCUMENTATION = "https://docs.ablelytics.com"
export const URL_DOCUMENTATION_API = `${URL_DOCUMENTATION}/docs/api-and-integrations`



export const URL_APP_WORKSPACE = "/workspace"
export const URL_AUTH_LOGIN = `/login`
export const URL_AUTH_REGISTER = `/signup`


export const main_menu_urls = [
    {url: URL_FRONTEND_FEATURES, title:'Features'},
    {url: URL_FRONTEND_SOLUTIONS, title:'Solutions'},
    {url: URL_FRONTEND_PRICING, title:'Pricing'},
    {url: URL_FRONTEND_FAQS, title:'FAQs', ariaLabel:'Frequently Asked Questions'},
    {url: URL_FRONTEND_CONTACT, title:'Contact'},
];

export const main_menu_mobile_urls = main_menu_urls;